(function ($) {
    var sortPriorityCounter = 300;

    $.fn.orderby = function (options) {
        options = $.extend({
            cssSortable: 'sortable',
            cssSortAsc: 'sort-asc',
            cssSortDesc: 'sort-desc',
            multiSortKey: 'shiftKey'
        }, options);

        return this.each(function () {
            var table = $(this),
                headers = table.find('thead th.' + options.cssSortable + ', thead td.' + options.cssSortable);

            // disableSelection() function needs jQuery UI
            if ('disableSelection' in headers) {
                headers.disableSelection();
            }

            headers.click(function (event) {
                var header = $(this),
                    isSortedAsc = header.hasClass(options.cssSortAsc),
                    isSortedDesc = header.hasClass(options.cssSortDesc);

                if (!header.hasClass(options.cssSortable)) {
                    return false;
                }

                if (!event[options.multiSortKey]) {
                    headers.removeClass(options.cssSortAsc).removeClass(options.cssSortDesc);
                }

                if (isSortedAsc) {
                    header.removeClass(options.cssSortAsc).addClass(options.cssSortDesc);
                } else if (isSortedDesc) {
                    header.removeClass(options.cssSortDesc).addClass(options.cssSortAsc);
                } else {
                    var defaultSort = header.data('sortDefault');
                    if (defaultSort !== 'asc' && defaultSort !== 'desc') {
                        defaultSort = 'asc';
                    }
                    header.addClass(defaultSort === 'asc' ? options.cssSortAsc : options.cssSortDesc);
                }
                header.data('sortPriority', ++sortPriorityCounter);

                var sorting = headers.filter(function () {
                    return $(this).hasClass(options.cssSortAsc) || $(this).hasClass(options.cssSortDesc);
                }).map(function () {
                    var header = $(this);
                    return {
                        name: header.data('sortName'),
                        direction: header.hasClass(options.cssSortAsc) ? 1 : -1,
                        sortPriority: +header.data('sortPriority') || 0
                    };
                });

                sorting = _.chain(sorting).sortBy('sortPriority').map(function (item) {
                    return _.omit(item, 'sortPriority');
                }).value();

                table.trigger('sorted', [sorting]);

                return false;
            });
        });
    };
})(jQuery);
